<template>
  <div  class="img-ssr-vue-div flexCenter"  :style="style" ref="imgdiv" v-if="imgshow||!src">
    <img title="" src="defaultSrc" alt="" v-if="defaultSrc" class="img-ssr-vueshowsrc1">
    <img title="" :src="src1" alt=""
         class="img-ssr-vueshowsrc1"  v-else>
  </div>

  <div v-else class="img-ssr-vue-div flexCenter">
    <img title="" :src="src" :alt="alt" @error="error" class="img-ssr-vueshowsrc"  v-if="src.indexOf(';base64,')!=-1"/>
    <img title="" :src="src" :alt="alt" @error="error" class="img-ssr-vueshowsrc"  v-else-if="src.indexOf('blob:http:') != -1"/>
    <img title="" :src="src" :alt="alt" @error="error" class="img-ssr-vueshowsrc"  v-else-if="src.indexOf('.gooeto.com') == -1"/>
    <img title="" :src="src+'?mediaToken=' + this.$store.state.userinfo.mediaToken"   @error="error" class="img-ssr-vueshowsrc"  v-else/>
  </div>
</template>

<script>
import { myFun}  from '../../plug/modifyImagePath'
export default {
  name: 'VueImg',
  data () {
    return {
      imgshow: false,
      style: {},
      src1: myFun("https://jusewebapp.oss-cn-hangzhou.aliyuncs.com/guyiWebapp%2Fdefault_logo.png"),
    };
  },
  props: {
    src: {
      type: String,
      default: 'https://jusewebapp.zmelo.com/guyiWebapp%2Fdefault_logo.png',
    },
    alt: {
      type: String,
      default: '',
    },
    defaultSrc: {
      type: String,
      default: () => '',
    },
    cache: {
      type: Boolean,
      default: () => false,
    },
  },
  watch: {
    src () {
      this.imgshow = false;
    },
  },
  methods: {
    error () {
      this.imgshow = !this.imgshow;
    },
  },
  mounted () {
    // console.log(this.src + '?mediaToken='+this.$store.state.userinfo.mediaToken);
  },
  filters: {

  },

};
</script>



// WEBPACK FOOTER //
// VueImg.vue